export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0/static/icon-splash-bottom-text-light-640a57bc0f9146ec4ec965ec542fa94b.svg";